import React from "react";
import { Col, Row } from "react-bootstrap"; 
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiCodeigniter,
  DiLaravel ,
  DiGit,
  DiPhp ,
} from "react-icons/di";
 

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
       
      <Col xs={4} md={2} className="tech-icons">
        <DiPhp  />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiCodeigniter />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiLaravel  />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
      </Col>
       
      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
      </Col>
      
      <Col xs={4} md={2} className="tech-icons">
        <DiMongodb />
      </Col>
       
      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
      </Col>  
    </Row>
  );
}

export default Techstack;
